import { createUseStyles } from 'react-jss';

const styles = {
  header: {
    marginBottom: 0,
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
